import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center mt-32 -mb-20 text-2xl font-semibold text-gray-800" }, " Post Writer ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostWriter = _resolveComponent("PostWriter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_PostWriter, {
      post: _ctx.newPost,
      onSave: _ctx.save
    }, null, 8, ["post", "onSave"])
  ], 64))
}